import React from 'react';
import { cn } from '../../lib/utils';

const Input = React.forwardRef(({ label, error, helperText, className, id, ...props }, ref) => {
  const inputId = id || props.name;

  return (
    <label className='block space-y-2' htmlFor={inputId}>
      {label ? <span className='text-sm font-medium text-ink-800'>{label}</span> : null}
      <input
        id={inputId}
        ref={ref}
        className={cn(
          'w-full rounded-lg border bg-white px-4 py-3 text-ink-900 placeholder:text-ink-400 shadow-soft transition duration-200 ease-luxury focus:outline-none',
          error
            ? 'border-danger-500 focus:ring-2 focus:ring-danger-500/20'
            : 'border-pearl-400 focus:border-gold-500 focus:ring-2 focus:ring-gold-500/20',
          className
        )}
        {...props}
      />
      {error ? <p className='text-sm text-danger-500'>{error}</p> : helperText ? <p className='text-sm text-ink-500'>{helperText}</p> : null}
    </label>
  );
});

Input.displayName = 'Input';

export { Input };
